module.exports = __webpack_public_path__ + "static/media/black-bubble-speech.56dc9cf2.svg";